import * as url from 'config/url_api';

export const categoryTabs = [
  'Đội vô địch',
  'Vua phá lưới',
  // 'Đội nhận nhiều thẻ vàng nhất',
  // 'Đội bị loại đầu tiên',
  // 'Đội đầu tiên vào vòng 16',
  // 'Đội đầu tiên vào vòng 32',
  'Đội nhận thẻ đỏ đầu tiên',
  'Cầu thủ xuất sắc nhất',
  'Đội Châu Á Vào Sâu Nhất'
];

export const tabEndpointMap = {
  'Đội vô địch': url.API_WORLD_CUP_TEAMS_CHAMPIONS,
  'Vua phá lưới': url.API_WORLD_CUP_TOP_SCORER_PREDICTIONS,
  // 'Đội nhận nhiều thẻ vàng nhất': url.API_WORLD_CUP_TEAMS_YELLOW_CARD,
  // 'Đội bị loại đầu tiên': url.API_WORLD_CUP_TEAMS_ELIMINATED_FIRST,
  // 'Đội đầu tiên vào vòng 16': url.API_WORLD_CUP_TEAMS_ROUND16_FIRST,
  // 'Đội đầu tiên vào vòng 32': url.API_WORLD_CUP_TEAMS_ROUND32_FIRST,
  'Đội nhận thẻ đỏ đầu tiên': url.API_WORLD_CUP_FIRST_RED_CARD,
  'Cầu thủ xuất sắc nhất': url.API_WORLD_CUP_BEST_PLAYER_PREDICTIONS,
  'Đội Châu Á Vào Sâu Nhất': url.API_WORLD_CUP_FINAL_ASIA_TEAM
};

export const fallbackRankingData = [
  {
    name: 'Cristiano Ronaldo',
    point: 100,
    avatar: '/assets/images/header/logo.png',
    teamName: 'Bồ Đào Nha'
  },
  {
    name: 'Lionel Messi',
    point: 99,
    avatar: '/assets/images/header/logo.png',
    teamName: 'Argentina'
  },
  { name: 'Kylian Mbappé', point: 98, avatar: '/assets/images/header/logo.png', teamName: 'Pháp' },
  {
    name: 'Erling Haaland',
    point: 97,
    avatar: '/assets/images/header/logo.png',
    teamName: 'Na Uy'
  },
  {
    name: 'Lamine Yamal',
    point: 96,
    avatar: '/assets/images/header/logo.png',
    teamName: 'Tây Ban Nha'
  },
  {
    name: 'Antoine Griezmann',
    point: 95,
    avatar: '/assets/images/header/logo.png',
    teamName: 'Pháp'
  },
  { name: 'Kevin De Bruyne', point: 94, avatar: '/assets/images/header/logo.png', teamName: 'Bỉ' },
  {
    name: 'Son Heung-min',
    point: 93,
    avatar: '/assets/images/header/logo.png',
    teamName: 'Hàn Quốc'
  }
];

export const heroAvatar = '/assets/images/header/logo.png';
